import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from "@angular/core";

/**
 * Waagrechter Fortschritt ueber mehrere Schritte.
 *
 * `current` ist der laufende Schritt; alles davor gilt als erledigt. Ein
 * `current` hinter dem letzten Index markiert den ganzen Vorgang als fertig.
 */
@Component({
  selector: "app-stepper",
  templateUrl: "./stepper.component.html",
  styleUrls: ["./stepper.component.scss"],
  // ⚠ app-svg-icon haengt das SVG per Renderer2 ein; die Knoten tragen kein
  // _ngcontent, gekapselte Regeln wuerden den Haken nicht erreichen.
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StepperComponent {
  /** Uebersetzungsschluessel, einer je Schritt. */
  @Input() steps: Array<string> = [];

  @Input() current = 0;

  public isDone(index: number): boolean {
    return index < this.current;
  }

  public isActive(index: number): boolean {
    return index === this.current;
  }

  public track(index: number, step: string): string {
    return step;
  }
}
